import { KTSVG } from "./KTSVG"
import Toast from "react-bootstrap/Toast"
import { useState } from "react"
import { AlertModel } from "./AlertList"

type Props = {
    alert: AlertModel
}
export const ToastView: React.FC<Props> = ({ alert }) => {
    const [show, setShow] = useState(true);
    return (
        <Toast onClose={() => setShow(false)} show={show} delay={50000} autohide bg={`${alert.state}`}>
            <Toast.Header closeButton={true}>
                <KTSVG
                path={`/media/icons/${alert.state}.svg`}
                className={`rounded me-2 svg-icon-2 svg-icon-${alert.state}`}
                />
                <strong className="me-auto">{alert.title}</strong>
                {alert.time ? <small className="text-muted">{alert.time}</small> : <></>}
            </Toast.Header>
            <Toast.Body>
                <div className="toast-message toast-error">
                    {alert.description}
                </div>
            </Toast.Body>
        </Toast>
    );
}